import React, { useEffect, useState } from "react";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import Team from "./team/teamCard";
import { getTeams } from "services/teams_service";
import { Link } from "react-router-dom";

function App({ refresh }) {
  const [teams, setTeams] = useState([]);
  const [teamSub13, setTeamSub13] = useState([]);
  const [teamIniciados, setTeamIniciados] = useState([]);
  const [teamJuvenis, setTeamJuvenis] = useState([]);
  const [teamJuniores, setTeamJuniores] = useState([]);
  const [teamSeniores, setTeamSeniores] = useState([]);

  // get the teams in the backend;
  useEffect(() => {
    async function getTeamsFunc() {
      try {
        const teamList = await getTeams();
        setTeams(teamList);

        let teamSub13 = teamList.filter((el) =>
          ["Sub-13"].includes(el.attributes.level)
        );

        let teamIni = teamList.filter((el) =>
          ["Sub-15"].includes(el.attributes.level)
        );

        let teamJuveni = teamList.filter((el) =>
          ["Sub-17"].includes(el.attributes.level)
        );

        let teamJunior = teamList.filter((el) =>
          ["Sub-19"].includes(el.attributes.level)
        );

        let teamSenior = teamList.filter((el) =>
          ["Sénior"].includes(el.attributes.level)
        );

        setTeamSub13(teamSub13);
        setTeamIniciados(teamIni);
        setTeamJuvenis(teamJuveni);
        setTeamJuniores(teamJunior);
        setTeamSeniores(teamSenior);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getTeamsFunc();
  }, []);

  const canAddTeam = () => {
    if (localStorage.getItem("role") === "Clube") {
      return true;
    }

    return false;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>

          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li className="is-active">Plantéis</li>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Plantéis</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="teamblock">
              {teams.length === 0 &&
                localStorage.getItem("role") === "Clube" && (
                  <p>
                    Não tem nenhuma equipa. Crie uma equipa e comece já a gerir
                    os planteis, convocatórias e muito mais.
                  </p>
                )}
              {teams.length === 0 &&
                localStorage.getItem("role") !== "Clube" && (
                  <p>
                    Não se encontra em nenhuma equipa. Peça ao seu clube para o
                    convidar para uma equipa. Não poderá ver os jogos nem os
                    eventos até estar convidado.
                  </p>
                )}
              {teamSeniores.length > 0 && (
                <h2 className="bold" style={{ marginBottom: "30px" }}>
                  Séniores
                </h2>
              )}
              {teamSeniores.map((el, idx) => (
                <Team key={idx} id={el.id} team={el.attributes}></Team>
              ))}
              {teamJuniores.length > 0 && (
                <h2 className="bold" style={{ marginBottom: "30px" }}>
                  Sub-19
                </h2>
              )}
              {teamJuniores.map((el, idx) => (
                <Team key={idx} id={el.id} team={el.attributes}></Team>
              ))}
              {teamJuvenis.length > 0 && (
                <h2 className="bold" style={{ marginBottom: "30px" }}>
                  Sub-17
                </h2>
              )}
              {teamJuvenis.map((el, idx) => (
                <Team key={idx} id={el.id} team={el.attributes}></Team>
              ))}
              {teamIniciados.length > 0 && (
                <h2 className="bold" style={{ marginBottom: "30px" }}>
                  Sub-15
                </h2>
              )}
              {teamIniciados.map((el, idx) => (
                <Team key={idx} id={el.id} team={el.attributes}></Team>
              ))}

              {teamSub13.length > 0 && (
                <h2 className="bold" style={{ marginBottom: "30px" }}>
                  Sub-13
                </h2>
              )}
              {teamSub13.map((el, idx) => (
                <Team key={idx} id={el.id} team={el.attributes}></Team>
              ))}

              <br></br>
              <br></br>
              {canAddTeam() && (
                <span className="invisible-box teamCard">
                  <Link to={"/nova-equipa"}>
                    <i className="fa fa-plus circled-icon"></i>
                  </Link>
                </span>
              )}
            </div>
          </section>

          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
